import { render, staticRenderFns } from "./event-item.vue?vue&type=template&id=16e77742&scoped=true&"
import script from "./event-item.vue?vue&type=script&lang=js&"
export * from "./event-item.vue?vue&type=script&lang=js&"
import style0 from "./event-item.vue?vue&type=style&index=0&id=16e77742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e77742",
  null
  
)

export default component.exports